export const getCategory = store => (store.category ? store.category : {});
export const isLoaded = store => {
  let category = getCategory(store);
  return category.loaded != null && category.loaded;
};
export const getCategories = store => getCategory(store).categories;
